<template>
  <div>
    <form @submit.prevent="showData">
      <select v-model="selectMonth">
        <option v-for="month in month" :value="month.value" :key="month.index">
          {{ month.text }}
        </option>
      </select>
      <select v-model="selectNum">
        <option
          v-for="cardnum in cardnum"
          :value="cardnum.username"
          :key="cardnum.index"
        >
          {{ cardnum.username }}
        </option>
      </select>
      <button>表示する</button>
    </form>
    <button @click="delCardRireki">このカードの履歴を消去する</button>

    <div class="row">合計金額 {{ total | addComma }} 円</div>

    <div class="row">
      <table class="u-full-width">
        <tr>
          <th>ご利用日</th>
          <th>ご利用先</th>
          <th>ご利用金額</th>
        </tr>
        <tbody v-for="cardData in cardData" :key="cardData.index">
          <tr>
            <td>{{ cardData.updated_at }}</td>
            <td>{{ cardData.contentName }}</td>
            <td class="right_text">{{ cardData.price | addComma }}円</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: "CardAdmin",
  data() {
    return {
      username: "",
      selectMonth: "",
      month: [
        { text: "1月", value: "1" },
        { text: "2月", value: "2" },
        { text: "3月", value: "3" },
        { text: "4月", value: "4" },
        { text: "5月", value: "5" },
        { text: "6月", value: "6" },
        { text: "7月", value: "7" },
        { text: "8月", value: "8" },
        { text: "9月", value: "9" },
        { text: "10月", value: "10" },
        { text: "11月", value: "11" },
        { text: "12月", value: "12" },
      ],
      cardData: {},
      cardnum: {},
      selectNum: "",
      total: 0,
    };
  },
  created: function () {
    this.selectMonth = new Date().getMonth() + 1;
    this.username = this.$store.state.userName;
    this.$axios
      .get(
        this.$store.state.APIbase +
          "/records/users?include=username&order=username,"
      )
      .then((res) => {
        this.cardnum = res.data.records;
      });
  },
  methods: {
    showData: function () {
      var m;
      this.total = 0;
      if (this.selectMonth < 10) {
        m = new Date().getFullYear() + "-0" + this.selectMonth;
      } else {
        m = new Date().getFullYear() + "-" + this.selectMonth;
      }
      var param =
        "?filter=cardNum,eq," + this.selectNum + "&filter=updated_at,cs," + m;
      this.$axios
        .get(this.$store.state.APIbase + "/records/cards" + param)
        .then((res) => {
          this.cardData = res.data.records;
          this.cardData.forEach((element) => {
            this.total = this.total + element.price;
          });
        });
    },
    delCardRireki: function () {
      var idArray = [];
      var self = this;
      this.$axios
        .get(
          this.$store.state.APIbase +
            "/records/cards?filter=cardNum,eq," +
            self.selectNum +
            "&include=id"
        )
        .then((res) => {
          console.log(res.data);
          res.data.records.forEach((element) => {
            console.log(element.id);
            idArray.push(element.id);
          });
          console.log(idArray);
          self.$axios
            .delete(
              this.$store.state.APIbase + "/records/cards/" + idArray.join(",")
            )
            .then(() => {
              self.showData();
            });
        });
    },
  },
};
</script>

<style scoped>
.select {
  background: #bae8e8;
  box-shadow: 1px -1px 1px rgba(0, 0, 0, 0.3);
}
.right_text {
  text-align: right;
}
@media (max-width: 699px) {
  .nav {
    border-bottom: none;
  }
  .tab {
    border-radius: 10px;
    margin: 5px;
  }
}

form {
  margin-top: 2rem;
}
</style>